import profileImg from "./assets/images/profileImg.png";
import flacImg from "./assets/images/FLAC.jpg";
import eCommerceImg from "./assets/images/E-commerce.jpg";
import lendingApp from "./assets/images/LendingApp.jpg";


const logotext = "MICHIKO";
const meta = {
    title: "Michiko Chew",
    description: "I’m Michiko, full stack developer/ software engineer, looking for Singapore jobs",
};

const introdata = {
    title: "Hi, I'm Michiko, ",
    animated: {
        first: "Full Stack Developer",
        second: "Software Engineer",
        //third: "",
    },
    description: "Recently completed a Bachelor of Computer Science and " +
        "eagerly seeking job opportunities to learn and contribute. " +
        "Passion for backend development, especially Microservices architecture and " +
        "Blockchain technologies. Consistent using Java 11, Spring Boot, Spring Cloud, " +
        "and React in development.",
};

const dataabout = {
    profile: profileImg,
    para: ["Hello! My name is Michiko, and I enjoy tinkering with tech and building things on the internet. " +
        "My interest in software development started in 2019 when I turned a computer lab floor plan into a " +
        "seat-booking desktop app using JavaFX. It was my first-time turning paper requirement into a functional app! ",

    "At its onset, I had experience as a software developer developing, supporting, and testing web apps " +
    "within an agile environment in a global corporation. Beyond organization, I have been coding web and " +
    "native apps in a team and personally in the past. ",

    "I strive to maintain the efficiency of the software at an optimum level with clean, efficient, " +
    "and scalable code. The way to achieve this is by researching and practicing SOLID principles and " +
    "design patterns in OOD development work. Furthermore, " +
    "I practice competitive programming and flip through the pages whenever I am free.",

    ],
};
const worktimeline = [{
    id: 0,
    jobtitle: "Software Developer Intern",
    where: "Seagate Global Business",
    date: "2021",
    description: [
        "Experience 2+ SDLC by collaborating with multi-site Agile team(developers, Scrum Master, Product Owner, user...etc) work on manufacturing and R&D facilities project.",
        "Involved in CI/CD development and support applications (requirement gathering, code development, testing, and end product deployment) using SAFe Agile Development Methodology.",
        "Document every released feature and demo to application user synchronously using the staging app and supported with UML diagrams.",
        "Technologies used: Java Spring Boot, React, Typescript, Redux, SQL, Oracle, Jenkins"
    ]
},

];

const achievements = [{
    title: "Gold medal, 1st Runner Up, Best Presenter award",
    date: "2022",
    issuer: "PIXEL panel",
    description: [
        "Innovate interactive financial learning gamification process for children with parent monitoring.",
    ],
    eventUrl: "https://pixel.usm.my/awards/special"
},
{
    title: "Certificate of Excellence Internship award",
    date: "2021",
    issuer: "Seagate Manager",
    description: [
        "Exceeded planned deliverables in producing solutions and creating an inclusive environment during the internship.",
    ],
    eventUrl: "https://cs.usm.my/index.php/news-events/news-cs/577-congratulations-to-all-the-winners"
},


];

const skills = [{
    name: "Programming Languages",
    tools: [
        "Java", "JavaScript", "C++"
    ]
},
{
    name: "Framework",
    tools: [
        "SpringBoot", "Spring", "React", "Node", "Express"
    ]
},
{
    name: "Database",
    tools: [
        "MySQL", "MongoDB", "Oracle"
    ]
},
{
    name: "Tools",
    tools: [
        "RabbitMQ", "Docker", "Swagger", "AWS"
    ]
},
];

const education = [{
    title: "Bachelor Degree of Computer Science (Software Engineering), CGPA 3.82/4.0",
    startYear: "2018",
    endYear: "2022",
    location: "Universiti Sains Malaysia"
}]

const goals = [{
    title: "Contribute community",
    description: "During university life, I enjoy helping friends and juniors solve problems- " +
        "explaining how network packet switching works, setting up IDE, etc. " +
        "However, timidness daunting me when I want to share resources on the Internet. " +
        "I tend to feel that I am not good enough or might even share incorrect resources. " +
        "It is certainly not true as there is no right and wrong for sharing knowledge " +
        "as long as some things you share are from a true source and you have the good heart to help others.",
    wishlist: [{
        status: false,
        title: "Share more than 5 quality posts on the Medium platform."
    }, {
        status: false,
        title: "Contribute to at least one open-source project."
    }
    ]

},
{
    title: "Challenge myself",
    description: "I was a bundle of nerves when participating in any competition, " +
        "even though I joined some relevant and irrelevant competitions in the past, Hackathon, " +
        "Orchestra band competition (in case you wonder what I am playing, it is clarinet), etc. " +
        "Can't deny that it is a fast learning approach with a remarkable experience.",
    wishlist: [{
        status: false,
        title: "Being more active by joining at least one hackathon."
    },
    ]

}
];

const dataportfolio = [{
    img: lendingApp,
    title: "Loan Management App",
    description: "Curiosity about how money is handled in Object-Oriented Design " +
        "drives this project's development. Along with the loan transaction logic implementation, " +
        "I learn how to tackle money precision and code flexibility by utilizing suitable " +
        "data structure and OOB principles. RabbitMQ message broker had been used to prevent data loss " +
        "between services communication in case services are down.",
    tools: ["SpringBoot", "Java", "RabbitMQ", "JPA", "H2"],
    link: {
        github : "https://github.com/michikochew98/loan-management-app",
    }
},
{
    img: flacImg,
    title: "Financial Learning App for Children",
    description: "During the pandemic, news shared that a parent does financial teaching " +
        "by letting their child do chores for earnings and spend at a 'small canteen' in their house. " +
        "This embarks me to create a digital app that allows kids to perform those transactions " +
        "using virtual money. Additionally, simple logic was created that forces kids to have " +
        "to save and investing habits.",
    tools: ["SpringBoot", "Java", "React Native", "JavaScript", "MongoDB", "MySQL"],
    link: {
        youtube : "https://youtu.be/uOFbTu2UXNc",
    }
},
{
    img: eCommerceImg,
    title: "E-Commerce Platform",
    description: "Still, remember feedback from the interviewer in the last two years before. " +
        "He reminds me of the importance of selecting tools based on the project's needs. " +
        "Different frameworks provide different advantages. MERN frameworks play like a charm for " +
        "speedy development and heavy IO project. That is why I picked up basic MERN knowledge and " +
        "applied it to this full-stack project.",
    tools: ["React", "Redux", "NodeJS", "Express", "MongoDB Atlas"],
    link: {
        github : "https://github.com/michikochew98/E-commerce-platform",
    }
},
];

const contactConfig = {
    YOUR_EMAIL: "michikochew98@gmail.com",
    description: "Don't be a stranger. Drop me a line. ",
    // creat an emailjs.com account 
    // check out this tutorial https://www.emailjs.com/docs/examples/reactjs/
    YOUR_SERVICE_ID: "service_r8sy4ta",
    YOUR_TEMPLATE_ID: "template_w57htth",
    YOUR_PUBLIC_KEY: "Z_Bhl6v0kwCG_VLWb",
};

const socialprofils = {
    github: "https://github.com/michikochew98",
    facebook: "https://facebook.com",
    linkedin: "https://www.linkedin.com/in/mi-chi-ko/",
    twitter: "https://twitter.com",
    youtube: "https://youtube.com",
    twitch: "https://twitch.com",
};
export {
    meta,
    dataabout,
    dataportfolio,
    worktimeline,
    skills,
    achievements,
    education,
    goals,
    introdata,
    contactConfig,
    socialprofils,
    logotext,
};
